import { BaseAction } from './ActionInterface';
import { ActionTypes } from './ActionTypes';
import { BeerState } from '../types';

/**
 * Set Active Tab Action
 * Updates the currently active tab in the UI
 */
export class SetActiveTabAction extends BaseAction<string> {
  type = ActionTypes.SET_ACTIVE_TAB;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      ui: {
        ...state.ui,
        activeTab: this.payload || 'all',
      },
    };
  }
}

/**
 * Set Has Active Filters Action
 * Updates whether there are active filters in the UI
 */
export class SetHasActiveFiltersAction extends BaseAction<boolean> {
  type = ActionTypes.SET_HAS_ACTIVE_FILTERS;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      ui: {
        ...state.ui,
        hasActiveFilters: this.payload === true, // Ensure it's a boolean
      },
    };
  }
}

/**
 * Set Selected Beer Action
 * Sets the currently selected beer for the action bar
 */
export class SetSelectedBeerAction extends BaseAction<string | null> {
  type = ActionTypes.SET_SELECTED_BEER;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      ui: {
        ...state.ui,
        selectedBeerId: this.payload ?? null,
      },
    };
  }
}

/**
 * Clear Selected Beer Action
 * Clears the currently selected beer
 */
export class ClearSelectedBeerAction extends BaseAction<void> {
  type = ActionTypes.CLEAR_SELECTED_BEER;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      ui: {
        ...state.ui,
        selectedBeerId: null,
      },
    };
  }
}

/**
 * Set Filter Bar Height Action
 * Updates the height of the active filters bar for dynamic content offset
 */
export class SetFilterBarHeightAction extends BaseAction<number> {
  type = ActionTypes.SET_FILTER_BAR_HEIGHT;
  
  execute(state: BeerState): BeerState {
    return {
      ...state,
      ui: {
        ...state.ui,
        filterBarHeight: this.payload || 0,
      },
    };
  }
}
